export default __webpack_public_path__ + "static/img/grs.0e97ffa.png";